module.exports = __webpack_public_path__ + "img/肌如初雪套装_02.59ed59db.jpg";